<form [formGroup]='formGroup' class='mb-2'>
  <div class='input-group input-group-sm input-group--treatment'>
    <label [htmlFor]='inputId' [innerHTML]='label' class="form-label"></label>
    <input [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           aria-describedby='ptWInputHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='value'
           type='text'>

    <div [ngSwitch]='status' class='input-group-text'>
      <ng-container *ngSwitchCase="'DRAFT'">
        <div *ngIf='!completed else COMPLETED'
             [ngbTooltip]='noCompletedMessage' container='body'
             placement='left'>
          <button
            (click)='publicTreatment.emit()'
            [disabled]='!enabledEdit'
            class='btn btn-sm btn-primary min-width-60 mt-1 float-end'>
            {{ 'BUTTON.PUBLIC' | translate }}
          </button>
        </div>
        <ng-template #COMPLETED>
          <button
            (click)='publicTreatment.emit()'
            [disabled]='!enabledEdit'
            class='btn btn-sm btn-primary min-width-60 mt-1 float-end'>
            {{ 'BUTTON.PUBLIC' | translate }}
          </button>
        </ng-template>
      </ng-container>
      <button (click)='reopenTreatment.emit()'
              *ngSwitchCase="'PUBLISHED'"
              [disabled]='!enabledEdit'
              class='btn btn-sm btn-primary min-width-60 float-end'>
        {{ 'BUTTON.REOPEN_PROCESS' | translate }}
      </button>
      <button *ngSwitchCase="'VALIDATED'"
              class='btn btn-sm btn-success min-width-60 float-end'
              disabled>
        {{ 'BUTTON.PUBLIC' | translate }}
      </button>

      <button *ngSwitchCase="'ARCHIVED'"
              class='btn btn-sm btn-warning min-width-60 float-end'
              disabled>
        {{ 'BUTTON.PUBLIC' | translate }}
      </button>
      <div *ngSwitchDefault>{{ ND }} {{ status }}</div>
    </div>
  </div>
</form>
